<template>
  <footer class="main-footer d-flex p-2 px-3 bg-white border-top">
    <div :class="[contained ? 'container' : 'container-fluid']">
      <div class="align-items-center row h-100 text-right">
        <span class="copyright col-12 ml-auto my-auto mr-2">Copyright © 2019-{{new Date().getFullYear()}} Sync360.io</span>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'main-footer',
  props: {
    /**
       * The copyright information.
       */
    copyright: {
      type: String,
      default: 'Copyright © 2019 Sync360.io',
    },
    /**
       * Whether the footer should be wrapped in a container, or not.
       */
    contained: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
